import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import Label from '@material-ui/icons/Label';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { useLocation } from 'react-router-dom';

//var userStore = JSON.parse(window.sessionStorage.getItem('user_store'));
var checkPermission = false;
var className = '';

const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    '&:hover > $content': {
      backgroundColor: theme.palette.action.hover
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)'
    },
    '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label':
      {
        backgroundColor: 'transparent'
      }
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular
    }
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2)
    }
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit'
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0)
  },
  labelIcon: {
    marginRight: theme.spacing(1)
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1
  }
}));
function StyledTreeItem(props) {
  const classes = useTreeItemStyles();
  const {
    labelText,
    labelIcon: LabelIcon,
    labelInfo,
    color,
    bgColor,
    ...other
  } = props;
  return (
    <TreeItem
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          <Typography variant="body2" className={classes.labelText}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </div>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label
      }}
      {...other}
    />
  );
}

StyledTreeItem.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  labelIcon: PropTypes.elementType.isRequired,
  labelInfo: PropTypes.string,
  labelText: PropTypes.string.isRequired
};

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400
  }
});

export default function MenuTreeView() {
  const classes = useStyles();
  const location = useLocation();

  var arrLink = [
    '/home',
    '/trang-chu',
    '/account',
    '/khai-bao-y-te',
    '/thong-tin-khai-bao-y-te',
    '/lich-su-khai-bao-y-te',
    '/xu-ly-phieu-tra-loi',
    '/quan-ly-phieu-tra-loi'
  ];

  arrLink.forEach((value) => {
    if (value === location.pathname) {
      checkPermission = true;
      className = 'Mui-selected makeStyles-selected-20';
    }
    if (location.pathname.startsWith('/xu-ly-phieu-tra-loi/')) {
      checkPermission = true;
      className = 'Mui-selected makeStyles-selected-20';
    }
  });
  if (!checkPermission) {
    window.location.href = '/not-found';
  }
  return (
    <TreeView
      className={classes.root}
      defaultExpanded={['3000', '4000', '5000', '6000']}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}>
      {
        <StyledTreeItem
          nodeId="4000"
          labelText="QUẢN LÝ KHAI BÁO Y TẾ"
          labelIcon={Label}
          dataId={1}>
          <a href="/khai-bao-y-te">
            <StyledTreeItem
              className={
                window.location.pathname == '/khai-bao-y-te' ? className : ''
              }
              nodeId="4002"
              labelText="khai báo y tế"
              labelIcon={SupervisorAccountIcon}
              color="#1a73e8"
              bgColor="#e8f0fe"
              dataId={1}
            />{' '}
          </a>
          <a href="/thong-tin-khai-bao-y-te">
            <StyledTreeItem
              className={
                window.location.pathname == '/thong-tin-khai-bao-y-te'
                  ? className
                  : ''
              }
              nodeId="4003"
              labelText="Thông tin khai báo y tế"
              labelIcon={SupervisorAccountIcon}
              color="#1a73e8"
              bgColor="#e8f0fe"
              dataId={2}
            />{' '}
          </a>
          <a href="/lich-su-khai-bao-y-te">
            <StyledTreeItem
              className={
                window.location.pathname == '/lich-su-khai-bao-y-te'
                  ? className
                  : ''
              }
              nodeId="4004"
              labelText="Lịch sử khai báo y tế"
              labelIcon={SupervisorAccountIcon}
              color="#1a73e8"
              bgColor="#e8f0fe"
              dataId={3}
            />{' '}
          </a>
        </StyledTreeItem>
      }
    </TreeView>
  );
}
